import { useEffect, useRef, useState } from 'react';
import { Container, Alert, Spinner } from 'react-bootstrap';
import { verifySignup } from '../services/api';

// Lands here from the verification email (/verify?token=...). POSTs the token,
// which provisions the tenant, then redirects to the new subdomain.
export default function VerifyPage() {
  const [error, setError] = useState<string | null>(null);
  const [url, setUrl] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;       // guard React StrictMode double-invoke
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) { setError('Nedostaje token za potvrdu.'); return; }
    verifySignup(token)
      .then((res) => {
        const target = res.data?.url;
        setUrl(target || null);
        if (target) setTimeout(() => { window.location.href = target; }, 2000);
      })
      .catch((err) => {
        const msg = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
        setError(msg || 'Potvrda nije uspjela.');
      });
  }, []);

  return (
    <Container className="py-5" style={{ maxWidth: 520 }}>
      {error ? (
        <Alert variant="danger">
          <Alert.Heading>Potvrda nije uspjela</Alert.Heading>
          <p className="mb-0">{error}</p>
          <p className="mb-0 mt-2"><a href="/signup">Pokušaj ponovno</a></p>
        </Alert>
      ) : url ? (
        <Alert variant="success">
          <Alert.Heading>Restoran je spreman! 🎉</Alert.Heading>
          <p className="mb-2">Preusmjeravamo vas na vaš prostor:</p>
          <a href={url}>{url}</a>
        </Alert>
      ) : (
        <div className="text-center py-4">
          <Spinner animation="border" variant="secondary" /> <span className="ms-2">Potvrđujemo i kreiramo vaš restoran…</span>
        </div>
      )}
    </Container>
  );
}
